import * as constants from "../../../../constants";
import environment from "../../../../environments/environment";
import { notifyUser } from "../../Utils/notifyUser";
import { axiosInterceptor } from "../authInterceptor";

const DOWNLOAD_DOCS_BY_ID = environment.getClientStatementPDF;


export async function getMonthlyListDetails(Vivo: any) {
  try {
    const getMonthlyCalculationResponse = await axiosInterceptor.post(`${environment.postMonthlyCalculationsList}`, Vivo);
    return getMonthlyCalculationResponse;
  } catch (error: any) {
    return error;
  }
}

export async function getAllParticipants(Vivo: any) {
  try {
    const getAllParticipantsResponse = await axiosInterceptor.post(`${environment.postParticipants}`, Vivo);
    return getAllParticipantsResponse;
  } catch (error: any) {
    return error;
  }
}

export async function getEntityNamesByPId(participantId: number, entityType: string, clientId: number) {
  try {
    const resLoanSummaryByPId = await axiosInterceptor.get(`${environment.monthlyCalculationsByPID}/${participantId}?entityType=${entityType}&clientId=${clientId}`);
    return resLoanSummaryByPId;
  } catch (error: any) {
    return error;
  }
}
// monthly-batch-log/calculations?numOfMonths=6&currentMonth=3&clientId=1
export async function getMonthsList(NumberOfMonths: number, CurrentMonth: number, clientId: number) {
  try {
    const resLoanSummaryByPId = await axiosInterceptor.get(`${environment.getMonthsList}?numOfMonths=${NumberOfMonths}&currentMonth=${CurrentMonth}&clientId=${clientId}`);
    return resLoanSummaryByPId;
  } catch (error: any) {
    return error;
  }
}

export async function getIntrestRateForSavings(id: number, Pid: number, timestamp: number, clientId: number) {
  try {
    const response = await axiosInterceptor.get(`${environment.savingsIntrestRate}/${id}/interest/participant/${Pid}?date=${timestamp}&clientId=${clientId}`);
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getIntrestRateForCheckings(Pid: number, timestamp: number, clientId: number) {
  try {
    const response = await axiosInterceptor.get(`${environment.checkingIntrestRate}?participantId=${Pid}&endDate=${timestamp}&clientId=${clientId}`);
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getIntrestRateForCreditLine(id: number, Pid: number, timestamp: string, clientId: number) {
  try {
    const response = await axiosInterceptor.get(`${environment.creditLineIntrestRate}/${id}/participant/${Pid}/monthly-interest?endDate=${timestamp}&clientId=${clientId}`);
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getAndPostIntrestRateForSavings(id: number, Pid: number, timestamp: number, clientId: number) {
  try {
    const response = await axiosInterceptor.get(`${environment.savingsIntrestRate}/${id}/interest/participant/${Pid}/post-external-system?date=${timestamp}&clientId=${clientId}`);
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getAndPostIntrestRateForCheckings(Pid: number, timestamp: number) {
  try {
    const response = await axiosInterceptor.post(`${environment.postCheckingIntrestRate}?participantId=${Pid}&endDate=${timestamp}`);
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getAndPostIntrestRateForCreditLine(id: number, Pid: number, timeStartstamp: string, timeEndstamp: string, clientId: number) {
  try {
    const response = await axiosInterceptor.get(`${environment.creditLineIntrestRate}/${id}/participant/${Pid}/monthly-interest/post-external-system?startDate=${timeStartstamp}&endDate=${timeEndstamp}&clientId=${clientId}`);
    return response;
  } catch (error: any) {
    return error;
  }
}
export async function getIntrestRateForAllEntity(allEntityVo: any) {
  try {
    const response = await axiosInterceptor.post(`${environment.getAllEntityIntrestRate} `, allEntityVo);
    return response;
  } catch (error: any) {
    return error;
  }
}
export async function getAndPostIntrestRateForAllEntity(allEntityVo: any) {
  try {
    const response = await axiosInterceptor.post(`${environment.postAllEntityIntrestRate} `, allEntityVo);
    return response;
  } catch (error: any) {
    return error;
  }
}
export async function downloadParticipantMonthlyStatement(date: any, PID: any, notification: string, download: string, clientId: number) {
  try {
    const response = await axiosInterceptor.post(`${DOWNLOAD_DOCS_BY_ID}${date}/${PID}?notification=${notification}&download=${download}&clientId=${clientId}`);
    return response;
  } catch (error: any) {
    return error;
  }
}